import { AccountType, ClaimDirectDepositRequest } from '@bybeam/platform-types';
import RadioGroup from '@platform-ui-common/components/RadioGroup/index.js';
import useForm, { requiredField } from '@platform-ui-common/hooks/useForm/index.js';
import { AccountTypesDisplay } from '@platform-ui-common/utilities/payment.js';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';
import ClaimForm from '@platform-ui/claim/components/ClaimForm/index.js';
import useClaim from '@platform-ui/claim/hooks/useClaim.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { useHistory } from 'react-router';

function ACHAccountType(): JSX.Element {
  const { fulfillmentId, payload, setPayload } = useClaim<ClaimDirectDepositRequest>();
  const { formData, dispatch, errors, trySubmit } = useForm(
    { accountType: (payload?.bankAccount?.accountType ?? '') as AccountType },
    { accountType: requiredField() },
  );

  const history = useHistory();
  const onSubmit = (): void =>
    trySubmit(() => {
      setPayload({
        ...payload,
        bankAccount: { ...payload?.bankAccount, accountType: formData.accountType },
      });
      history.push(makeRoute(ClaimRoutes.ACH_ACCOUNT_NUMBER, { fulfillmentId }));
    });
  const errorMessages = Object.values(errors).flat();

  const items = [
    { label: AccountTypesDisplay[AccountType.Checking], value: AccountType.Checking },
    { label: AccountTypesDisplay[AccountType.Savings], value: AccountType.Savings },
  ];

  return (
    <ClaimForm
      header="Select your account type"
      subHeader="Please select one option:"
      onSubmit={onSubmit}
      errors={errorMessages}
    >
      {/* TODO fill to 320px */}
      <div className="w-full max-w-[320px]">
        <RadioGroup
          items={items}
          selectedValue={formData.accountType}
          onChange={(value: HTMLInputElement['value']): void =>
            dispatch({
              type: 'simpleUpdate',
              payload: { field: 'accountType', value: value as AccountType },
            })
          }
          error={!!errors?.accountType}
          name="accountType"
        />
      </div>
    </ClaimForm>
  );
}

export default ACHAccountType;
